/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Time: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M4.92893 4.92893C8.83417 1.02369 15.1663 1.02369 19.0715 4.92893C22.9768 8.83418 22.9768 15.1663 19.0715 19.0715C15.1663 22.9768 8.83418 22.9768 4.92893 19.0715C1.02369 15.1663 1.02369 8.83417 4.92893 4.92893ZM17.6574 6.34299C14.5333 3.2188 9.46719 3.2188 6.34299 6.34299C3.2188 9.46719 3.2188 14.5333 6.34299 17.6574C9.46719 20.7816 14.5333 20.7816 17.6574 17.6574C20.7816 14.5333 20.7816 9.46719 17.6574 6.34299ZM12.0002 7.50022C12.5525 7.50022 13.0002 7.94794 13.0002 8.50022V12.0002H15.5002C16.0525 12.0002 16.5002 12.4479 16.5002 13.0002C16.5002 13.5525 16.0525 14.0002 15.5002 14.0002H12.0002C11.4479 14.0002 11.0002 13.5525 11.0002 13.0002V8.50022C11.0002 7.94794 11.4479 7.50022 12.0002 7.50022Z'
      fill='currentColor'
    />
  </React.Fragment>
)
